import { render, staticRenderFns } from "./AddEditLecture.vue?vue&type=template&id=62d9a276"
import script from "./AddEditLecture.vue?vue&type=script&lang=js"
export * from "./AddEditLecture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports